import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { edgesApi } from '@/api/endpoints/edges'
import { getErrorMessage } from '@/shared/utils/error-codes'
import { ApiError } from '@/api/types'

export function usePairingCode() {
  return useMutation({
    mutationFn: ({
      restaurantId,
      ttlSeconds,
    }: {
      restaurantId: number
      ttlSeconds: number
    }) => edgesApi.createPairingCode(restaurantId, ttlSeconds),
    onError: (error: Error) => {
      if (error instanceof ApiError) {
        toast.error(getErrorMessage(error.status, error.code))
      } else {
        toast.error('Failed to create pairing code')
      }
    },
  })
}
